<script>
  import { docs, docsUpdated } from "./constants";
  import List from "./List.svelte";
</script>

<h3 class="m-0 text-sm transition-all top-7 right-7 tracking-widest absolute group-hover:text-true-gray-50">更新于 {docsUpdated}</h3>

<List items={docs} name="docs" />
